import { addLabels, isActive } from "@gr-exports/async/apm";
import { getBodyElement } from "@gr-exports/async/dom";
import { toggle } from "@gr-exports/async/toggle";

const pPattern = /(\sp_|^p_)/im;
const plPattern = /(\spl_|^pl_)/im;
const moPattern = /(\smo-|^mo-)/im;

/**
 *
 *
 */
export async function trackLegacySelectors(): Promise<void> {
  if (!(await isActive())) return;
  if (!toggle.get("gr_track_legacy_pali_selectors", false)) return;

  /*                                            */
  const nodes = Array.from(getBodyElement().querySelectorAll("*"));
  const classes = nodes.map((el) => el.className).filter((cl) => cl.length > 0);

  /*                                                                   */
  const [pSelectors, plSelectors, moSelectors] = ([pPattern, plPattern, moPattern] as const).map(
    (p) => {
      return classes.filter((cl) => p.test(cl)).length;
    },
  );

  /*                                                         */
  addLabels({
    dom_nodes: nodes.length,
    dom_legacy_selectors: pSelectors + plSelectors + moSelectors,
    dom_legacy_p_selectors: pSelectors,
    dom_legacy_pl_selectors: plSelectors,
    dom_legacy_mo_selectors: moSelectors,
  });
}
